"use client";

import React from "react";

//Type
import { CardServiceProps } from "@/types";

//Style
import * as S from "./styles";

//Icons
import { Pencil, Scissors, Trash } from "lucide-react";

//Components
import ButtonIcon from "../buttonIcon";

const CardService: React.FC<CardServiceProps> = ({
  className,
  titleCard,
  textDescription,
  price,
  time,
}) => {
  return (
    <S.CardService>
      <S.HeaderCard>
        <S.FirstBox>
          <S.BoxIcon>
            <Scissors />
          </S.BoxIcon>
          <S.TitleCard>Serviço</S.TitleCard>
        </S.FirstBox>
        <S.LastBox>
          <ButtonIcon icon={<Pencil />} hovercolor="green" />
          <ButtonIcon icon={<Trash />} hovercolor="red" />
        </S.LastBox>
      </S.HeaderCard>
      <S.BodyCard>
        <S.TextDescription>
          Modelagem e aparamento de barba com toalha quente
        </S.TextDescription>
      </S.BodyCard>
      <S.FooterCard>
        <S.Value>R$45</S.Value>
        <S.Time>35 min</S.Time>
      </S.FooterCard>
    </S.CardService>
  );
};

export default CardService;
